// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1OkP8","title":"Header_title__1uF2K","left":"Header_left__11cWZ","clinicName":"Header_clinicName__1Uari"};